
import React from 'react';
import { useParams } from 'react-router-dom';
import exact from 'prop-types-exact';
import News from '../../components/news/containers/NewsPageContainer';
import { getNewsCategoryIfNeeded } from '../../components/news/actions/NewsActions';
import { getNewsArchivePage } from '../../components/news/actions/NewsArchiveActions';
import { parseNewsPage } from '../../../api/utils/newsPagination';
// import SupportingText from '../../common/supportingText/SupportingText';

// const supportingTextInfo = {
//     title: 'Fique por dentro',
//     description: `de tudo o que acontece nos bastidores do mundo da música, desde lançamentos, shows, homenagens, parcerias e curiosidades sobre o seu artista favorito.
//         A vinda de artistas ao Brasil, cantores e bandas confirmadas no Lollapalooza e no Rock in Rio, ações beneficentes, novos álbuns, singles e clipes. Além disso, você acompanha conosco a cobertura das principais premiações do mundo como o Oscar, Grammy Awards, BRIT Awards, American Music Awards e Billboard Music Awards.
//         Leia as novidades sobre Phil Collins, Coldplay, U2, Jamiroquai, Tears for Fears, Céline Dion, Ed Sheeran, A-ha, Shania Twain, Culture Club, Spice Girls, entre outros.
//         Aproveite também e ouça esses e outros artistas no aplicativo da Rádio Antena 1, baixe na Apple Store ou Google Play e fique sintonizado.`,
// };

const Noticias = () => {
    const { category } = useParams();

    return (
        <div className="tw-container tw-m-auto tw-p-5">
            <News category={category || 'tudo'} />
            {/* <SupportingText title={supportingTextInfo.title} description={supportingTextInfo.description} /> */}
        </div>
    );
};

Noticias.fetchData = (store, match, query = {}) => {
    const page = parseNewsPage(query.page);
    const myPromises = [
        store.dispatch(getNewsCategoryIfNeeded()),
    ];

    if (page) myPromises.push(store.dispatch(getNewsArchivePage(page, match.params.category || 'tudo')));

    return Promise.all(myPromises);
};

Noticias.prototypes = exact({});

export default Noticias;
